import React, { useEffect, useState } from "react";
import { IoIosPersonAdd } from "react-icons/io";
import { toast } from "react-toastify";
import { useAuth } from "../../context/Auth";
import { RotatingLines } from "react-loader-spinner";
import { useGlobalContext } from "../../context/stateContext";

const CompanySettings = () => {
  const { requestWithAuth } = useAuth();
  const {company} = useGlobalContext()
  const [companyData, setCompanyData] = useState({});
  const [creatingDrug, setUpdating] = useState(false);
  

  const handleChange = (e) => {
    setCompanyData({ ...companyData, [e.target.name]: e.target.value });
  };

  

  const updateDetails = async (e) => {
    e.preventDefault();
    setUpdating(true);
    const body =JSON.stringify(companyData)
    try {
      const response = await requestWithAuth("/company/details/", "POST", body, {
        "Content-Type": "application/json",
        
      });
      setUpdating(false);
      toast.success("Details Updated Successfully");
      window.location.reload()
    } catch (error) {
      toast.error("Failed to update details. Please try again later.");
      
      setUpdating(false);
    }
  };
  

  return (
    <div className="px-[20px]">
      <div className="py-[32px] flex items-center gap-3">
        <IoIosPersonAdd className="text-[19px]" />
        <h4 className="text-[19px]">
          <b>System</b> - Company Settings
        </h4>
      </div>

      <div className="lg:w-[70%] mx-auto">
        <form onSubmit={(e) => updateDetails(e)} className="">
          <div className="mb-[20px] border border-[#ddd] rounded-[3px] bg-white pt-10">
            
            <div className="p-[20px] pt-0">
              <div className="flex items-center gap-2 mb-[20px] pb-[10px] uppercase border-b border-[#e5e5e5]">
                <IoIosPersonAdd className="text-[12px]" />
                <label htmlFor="item" className="text-[12px] font-[500]">
                  Company Details
                </label>
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div className="">
                  <label htmlFor="" className="font-[600]">
                    Company Name:
                  </label>
                  <input
                    type="text"
                    className="border border-[#ddd] rounded-[3px] h-[36px] w-full text-[#333] text-[13px] px-[12px] py-[7px]"
                    name="name"
                    value={companyData?.name ? companyData?.name : company?.name}
                    id=""
                    onChange={(e) => {
                      handleChange(e);
                    }}
                  />
                </div>
                <div className="">
                  <label htmlFor="" className="font-[600]">
                    Address:
                  </label>
                  <input
                    type="text"
                    className="border border-[#ddd] rounded-[3px] h-[36px] w-full text-[#333] text-[13px] px-[12px] py-[7px]"
                    name="address"
                    value={companyData?.address ? companyData?.address : company?.address}
                    id=""
                    onChange={(e) => {
                      handleChange(e);
                    }}
                  />
                </div>
                <div className="">
                  <label htmlFor="" className="font-[600]">
                    Phone Number:
                  </label>
                  <input
                    type="text"
                    value={companyData?.phone_number ? companyData?.phone_number : company?.phone_number}
                    className="border border-[#ddd] rounded-[3px] h-[36px] w-full text-[#333] text-[13px] px-[12px] py-[7px]"
                    name="phone_number"
                    id=""
                    onChange={(e) => {
                      handleChange(e);
                    }}
                  />
                </div>
                <div className="">
                  <label htmlFor="" className="font-[600]">
                    Website:
                  </label>
                  <input
                    type="text"
                    value={companyData?.website ? companyData?.website : company?.website}
                    className="border border-[#ddd] rounded-[3px] h-[36px] w-full text-[#333] text-[13px] px-[12px] py-[7px]"
                    name="website"
                    id=""
                    onChange={(e) => {
                      handleChange(e);
                    }}
                  />
                </div>
                
                
              </div>
              <div className="flex justify-end">
                {!creatingDrug ? (
                  <button className="bg-[#2196F3] px-[12px] py-[7px] text-[13px] rounded-[3px] mt-5 text-white">
                    Submit Form
                  </button>
                ) : (
                  <div className="bg-[#2195f3bb] cursor-wait px-[12px] py-[7px] text-[13px] rounded-[3px] mt-5 text-white flex items-center gap-2">
                    <RotatingLines
                      type="Grid"
                      strokeColor="white"
                      color="#fff"
                      width="15"
                      height="15"
                    />{" "}
                    Submitting
                  </div>
                )}
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CompanySettings;
